import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TrackingUtils, withPageContext } from '../../../../utils';
import { addSegment } from '../../../../redux/currentSearch/actions';
import { searcherConfigs, SearchProp, TripType } from '../../../../models';
import { isStopoverMode } from '../../../../redux/currentSearch/selectors';

export const AddSegment = ({ addSegment, currentSearch, isStopoverMode, trackEvent, render }) => {
    const [buttonLabel, setButtonLabel] = React.useState(searcherConfigs.default.addFlightButton.label);

    const { segments, tripType, config } = currentSearch;
    const max = config?.maxSegments[tripType];
    const shouldShow = tripType !== TripType.ROUND_TRIP && segments.length < max;

    const onClick = () => {
        const label = TrackingUtils.LABEL.addSegment(currentSearch);
        addSegment({ id: Date.now() });
        trackEvent({ action: TrackingUtils.ACTION.FLIGHTS, label });
    };

    React.useEffect(() => {
        if (isStopoverMode && segments.length === max - 1) {
            setButtonLabel(config.addFlightButton.label);
        } else {
            setButtonLabel(searcherConfigs.default.addFlightButton.label);
        }
    }, [config?.addFlightButton.label, isStopoverMode, max, segments]);

    return (
        <React.Fragment>
            {shouldShow && (
                <div className="FlightsManagerAddFlight odf-space-inner-bottom-s">
                    {render(onClick, buttonLabel)}
                </div>
            )}
        </React.Fragment>
    );
};

AddSegment.propTypes = {
    addSegment: PropTypes.func.isRequired,
    currentSearch: SearchProp.isRequired,
    render: PropTypes.func.isRequired,
    trackEvent: PropTypes.func.isRequired,
    isStopoverMode: PropTypes.bool.isRequired,
};

AddSegment.defaultProps = {
    addSegment: ()=>{},
    render: ()=>{},
    trackEvent: ()=>{},
    isStopoverMode: false,
};

const mapStateToProps = (state) => ({
    currentSearch: state.currentSearch,
    isStopoverMode: isStopoverMode(state)
});

export const ConnectedAddSegment = connect(mapStateToProps, {
    addSegment,
})(withPageContext(AddSegment));
